import type { Gradient } from '@jouzen/ecom-components';

const womensHealthHeroGradients: Gradient[] = [
  {
    shape: 'circle',
    hex: '#849671',
    id: 'olive-1',
    position: [10, 0],
    opacity: 0.4,
    size: 20,
  },
  {
    shape: 'circle',
    hex: '#849671',
    id: 'olive-2',
    position: [99, 40],
    opacity: 0.5,
    size: 40,
  },
  {
    shape: 'circle',
    hex: '#849671',
    id: 'olive-3',
    position: [10, 99],
    opacity: 0.6,
    size: 40,
  },
  {
    shape: 'circle',
    hex: '#849671',
    id: 'olive-4',
    position: [99, 70],
    opacity: 0.7,
    size: 20,
  },
];

export default womensHealthHeroGradients;
